export default "__VITE_ASSET__C4Y1kCyU__"